<template>
  <!-- <the-header></the-header> -->
  <router-view></router-view>
</template>

<script>
// import TheHeader from './components/nav/TheHeader.vue';

export default {
  // components: {
  //   TheHeader
  // }
  
 
  
 
};
</script>

<style>
* {
  box-sizing: border-box;
  direction: rtl;
}

html {
  font-family: var(--font-family);
}

body {
  margin: 0;
}

</style>